import { apiClient } from "~/services/apiClient";
import type {
  LoginResponse,
  VerifyOtpResponse,
} from "~/types/auth";

export async function login(email: string, password: string) {
  const response = await apiClient.post<LoginResponse>("/auth/login", {
    email,
    password,
  });
  return response.data;
}

export async function verifyOtp(preAuthToken: string, otp: string) {
  const response = await apiClient.post<VerifyOtpResponse>("/auth/otp-verify", {
    preAuthToken,
    otp,
  });
  return response.data;
}

export async function logout(hasActiveCall?: boolean) {
  if (typeof hasActiveCall === "boolean") {
    await apiClient.post("/auth/logout", { hasActiveCall });
    return;
  }
  await apiClient.post("/auth/logout");
}

export async function requestPasswordReset(email: string) {
  const response = await apiClient.post<{ message: string }>(
    "/auth/request-password-reset",
    { email }
  );
  return response.data;
}

export async function resetPassword(token: string, newPassword: string) {
  const response = await apiClient.post<{ message: string }>(
    "/auth/reset-password",
    { token, newPassword }
  );
  return response.data;
}

/**
 * Subscriber app accounts live apart from operator accounts, with their own endpoints, so their
 * reset email lands on the same screen in "app" mode and finishes here (AC-383).
 */
export async function requestMobilePasswordReset(email: string) {
  const response = await apiClient.post<{ message: string }>(
    "/api/mobile/request-password-reset",
    { email }
  );
  return response.data;
}

export async function resetMobilePassword(token: string, newPassword: string) {
  const response = await apiClient.post<{ message: string }>(
    "/api/mobile/reset-password",
    { token, newPassword }
  );
  return response.data;
}

export async function activateAccount(token: string, password: string) {
  const response = await apiClient.post<{ message: string }>(
    "/auth/activate-account",
    { token, password }
  );
  return response.data;
}
